<div #videoplayer
     id="media-player"
     data-vimeo-defer
     [attr.src]="videoUrl"
     [attr.data-plyr-provider]="videoType"
     [attr.data-plyr-embed-id]="videoUrl">
</div>
